import * as React from 'react';
import styled from 'styled-components';
import parser from 'html-react-parser';
import iconIlustration from '../../../../../../../../assets/icons/illustration.svg';
import { Heading } from '../../../../../../../components';
import {
  BlockPhoto,
  ButtonRequest,
  CommonBlock
} from '../../../IssuanceUniversityCard/info/components/Modals/styled';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 16px;
  // width: 296px;
  margin-bottom: 8px;
  .spanEllipsis {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #5b36f2;
    width: 100%;
    text-align: left;
    &:hover {
      cursor: pointer;
    }
  }

  .ellipsis {
    display: flex;
    flex-direction: column;
  }
  @media (min-width: 992px) {
    .ellipsis {
      display: flex;
      flex-direction: row;
    }
  }
  @media (min-width: 640px) {
    .spanEllipsis {
      display: inline-block;
      white-space: nowrap;
      overflow: inherit;
      text-overflow: ellipsis;
      width: auto;
    }
  }
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
`;

const Content = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;

  .types__tramite {
    margin-left: 30px;
    list-style: disc;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #161d1f;
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 6px;

  span {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  }
`;

const SubList = styled.li`
  // text-indent: -13px;
  // padding-left: 13px;
`;

const Subtitle = styled.p`
  margin-top: 16px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  color: #161d1f;

  a {
    color: var(--text-primary);
  }
`;

const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 992px) {
    display: flex;
    flex-direction: row;
    margin: 0px;
    align-items: center;

    a {
      margin-right: 382px;
      margin-left: 0px !important;
    }
  }
`;

interface StudyOptionDetailViewProps {
  handleClick: () => void;
}
const StudyOptionDetailView: React.FC<StudyOptionDetailViewProps> = (props) => {
  const { handleClick } = props;
  return (
    <CommonBlock>
      <Heading
        text="Opciones de estudio:"
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />

      <List>
        <SubList>
          <span>1) Semipresencial - 50% virtual.</span> Los créditos aprobados
          en modalidad virtual, a lo largo de la carrera, son 50%.
        </SubList>
        <SubList>
          <span>2) A distancia – 80% virtual</span> . Los créditos aprobados en
          modalidad virtual, a lo largo de la carrera, son 80%.
        </SubList>
        <SubList>
          <span>3) A distancia – 100% virtual.</span> Los créditos aprobados en
          modalidad virtual, a lo largo de la carrera, son 100%.
        </SubList>
      </List>
      <ButtonRequest className="optionsOk" onClick={() => handleClick()}>
        <p>Entendido</p>
      </ButtonRequest>
    </CommonBlock>
  );
};

const ProcessAvailableComponent: React.FC<StudyOptionDetailViewProps> = (
  props
) => {
  const { handleClick } = props;
  return (
    <CommonBlock>
      <BlockPhoto>
        <img src={iconIlustration} alt="error" />
      </BlockPhoto>
      <Heading
        text="Este trámite no se 
          encuentra disponible"
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />
      <ButtonRequest onClick={() => handleClick()}>
        <p>Entendido</p>
      </ButtonRequest>
    </CommonBlock>
  );
};

// const evalParagraphs = (value: string) => {
//   const paragraphs = value?.split('|');
//   return paragraphs?.length > 0 ? value?.split('|') : [value || ''];
// };
const ProcessComponent = (props: any) => {
  const { handleClick, title, subtitle, linkTo, hideImage = false } = props;
  // const paragraphs = evalParagraphs(
  //   'Por el momento la UTP no cuenta con una opción semipresencial y/o a distancia para tu carrera.|Las clases presenciales serán transmitidas en vivo por si no puedes asistir y además quedarán grabadas en tu plataforma.|Recuerda que las evaluaciones son presenciales.'
  // );

  // const paragraphs = evalParagraphs(subtitle);
  return (
    <CommonBlock>
      {!hideImage && (
        <BlockPhoto>
          <img src={iconIlustration} alt="error" />
        </BlockPhoto>
      )}
      <Heading
        text={parser(String(title))}
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />
      {/* {paragraphs.map((p) => (
          // <Subtitle key={IDHelper.generateID()}>{p}</Subtitle>
          <Subtitl>
            Sin embargo, dado que tu carrera no tiene opción Semipresencial o
            Virtual, la UTP ha equipado, solo para los cursos de tu carrera, las
            aulas presenciales con cámaras y micrófonos, de tal manera que las
            clases presenciales serán transmitidas en vivo y además quedarán
            grabadas. Si en alguna ocasión no puedes asistir, puedes ver la
            clase en vivo o luego puedes ver la clase grabada en la plataforma.
            Recuerda que las evaluaciones son presenciales.
          </Subtitl>
        ))} */}
      <Subtitle>
        {parser(String(subtitle))}{' '}
        {linkTo && (
          <a
            href="/tramites/autogestionables/solicitud/reincorporacion"
            style={{ color: 'var( --text-primary)' }}
          >
            {parser(String(linkTo))}
          </a>
        )}
      </Subtitle>

      <ButtonRequest onClick={() => handleClick()}>
        <p>Entendido</p>
      </ButtonRequest>
    </CommonBlock>
  );
};

export {
  Title,
  Content,
  List,
  SubList,
  Wrapper,
  Card,
  StudyOptionDetailView,
  ProcessAvailableComponent,
  ProcessComponent,
  ContentInfo
};
